import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";

export interface DebouncedSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  delay?: number;
  className?: string;
}

/**
 * Reusable debounced search input.
 * Calls onChange only after the user stops typing for {delay} ms.
 */
const DebouncedSearchInput: React.FC<DebouncedSearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search",
  delay = 400,
  className = "",
}) => {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (internalValue !== value) {
        onChange(internalValue);
      }
    }, delay);

    return () => clearTimeout(handler);
  }, [internalValue, value, delay, onChange]);

  return (
    <Form.Control
      type="text"
      value={internalValue}
      onChange={(e) => setInternalValue(e.target.value)}
      placeholder={placeholder}
      className={className}
    />
  );
};

export default DebouncedSearchInput;

